import { DocumentOrigin } from '../model/types';

export const EXTERNAL_DOCUMENT_NAME_PREFIX = '(DE) ';

type ExternalDocumentNameCandidate = {
  name?: string | null;
  title?: string | null;
  prefix?: string | null;
};

type ExternalDocumentCandidate = ExternalDocumentNameCandidate & {
  origin?: DocumentOrigin | null;
  config?: {
    origin?: DocumentOrigin | null;
  } | null;
  document?: ExternalDocumentNameCandidate | null;
};

function hasExternalOrigin(origin?: DocumentOrigin | null): boolean {
  return origin === DocumentOrigin.EXTERNAL;
}

function hasBlankPrefix(prefix?: string | null): boolean {
  return prefix?.trim() ? false : true;
}

function getDocumentName(candidate?: ExternalDocumentNameCandidate | null): string {
  return candidate?.name ?? candidate?.title ?? '';
}

export function hasExternalDocumentNameMarker(
  candidate?: ExternalDocumentNameCandidate | null
): boolean {
  return (
    hasBlankPrefix(candidate?.prefix) &&
    getDocumentName(candidate).startsWith(EXTERNAL_DOCUMENT_NAME_PREFIX)
  );
}

export function isExternalDocument(candidate?: ExternalDocumentCandidate | null): boolean {
  if (!candidate) {
    return false;
  }

  return (
    hasExternalOrigin(candidate.origin) ||
    hasExternalOrigin(candidate.config?.origin) ||
    hasExternalDocumentNameMarker(candidate.document) ||
    hasExternalDocumentNameMarker(candidate)
  );
}
